import React from 'react';
import SunburstPlot from "./widgets/SunburstPlot";

export default function SubSampleTaxonomy({ taxonomyTreeDataMultiple, highlightTaxon, setHighlightTaxon }) {
    console.log(highlightTaxon);

    // console.log(taxonomyTreeDataMultiple)
    // this component is no longer shown in the tabs
    return (
        <div>
            <p>Aggregate taxonomy information: </p>
            <SunburstPlot taxaData={taxonomyTreeDataMultiple} highlightTaxon={highlightTaxon} setHighlightTaxon={setHighlightTaxon} />
            {/* <SunburstPlot ref={sunburstRef} taxaData={taxonomyTreeDataMultiple} /> */}
            {/* <button onClick={handleDownload}>Download SVG</button> */}
        </div>
    );

}